module.exports = "/static/assets/af064208b0423eea068b4aa07d183364.png";